import { render, staticRenderFns } from "./VcaForm.vue?vue&type=template&id=9c9aa31e&scoped=true"
import script from "./VcaForm.vue?vue&type=script&lang=ts"
export * from "./VcaForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c9aa31e",
  null
  
)

export default component.exports